import { render, staticRenderFns } from "./SFTPFilesHeader.vue?vue&type=template&id=6e085e44&scoped=true&"
import script from "./SFTPFilesHeader.vue?vue&type=script&lang=js&"
export * from "./SFTPFilesHeader.vue?vue&type=script&lang=js&"
import style0 from "./SFTPFilesHeader.vue?vue&type=style&index=0&id=6e085e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e085e44",
  null
  
)

export default component.exports